import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FiatSymbolPipe } from "@modules/+new/shared/fiat-symbol-pipe/fiat-symbol.pipe";

@NgModule({
	declarations: [FiatSymbolPipe],
	imports: [CommonModule],
	exports: [FiatSymbolPipe],
	providers: [FiatSymbolPipe]
})
export class FiatSymbolPipeModule {}
